module.exports = __webpack_public_path__ + "static/media/process_orange.803c7b7f.svg";